<div class="form__container">
  <div class="form__header">
    <span>{{ title }}</span>
  </div>
  <div class="form__body">
    <ng-content select="[form-body]"></ng-content>
  </div>
  <div class="form__footer">
    @if (showCancelButton) {
      <div class="form__button-container">
        <app-action-button
          [buttonSize]="ActionButtonSize.Normal"
          [buttonType]="ActionButtonType.Cancel"
          (clicked)="cancel()"
        >{{ cancelText | translate }}</app-action-button>
      </div>
    }

    @if (additionalActionText) {
      <div class="form__button-container">
        <app-action-button
          [buttonSize]="ActionButtonSize.Normal"
          [buttonType]="ActionButtonType.Primary"
          [disabled]="additionalActionDisabled"
          (clicked)="additionalAction()"
        >{{ additionalActionText | translate }}</app-action-button>
      </div>
    }

    @if (showConfirmButton) {
      <div class="form__button-container">
        <app-action-button
          [buttonSize]="ActionButtonSize.Normal"
          [buttonType]="ActionButtonType.Confirm"
          [disabled]="confirmDisabled"
          (clicked)="submit()"
        >
          {{ confirmText | translate }}
        </app-action-button>
      </div>
    }
  </div>
</div>
